import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import { Environment, AllegatiCategoria, ModelNumStr } from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class AllegatiCategoriaService extends CrudGenericsService<AllegatiCategoria, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/AllegatiCategoria`);
    this.base = `${env.apiUrl}/api/AllegatiCategoria/`;
  }
  Get_ByAllegatoEPath(path: string): Observable<ModelNumStr[]> {
    const epath = btoa(path);
    const u = this.base + 'Get_ByAllegatoEPath?epath=' + epath;
    return this.http.get<ModelNumStr[]>(`${u}`);
  }
}
